import React, { useEffect, useState, createElement } from 'react';
import { Calendar, CheckCircle, Users, ArrowRight } from 'lucide-react';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
declare global {
  interface Window {
    fbq: any;
  }
}
export function BookCallInternalPage() {
  const [showSurvey, setShowSurvey] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'Book-Call-PV');
    window.fbq('trackCustom', 'Book-Call-Page');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const wistiaEmbedScript = document.createElement('script');
    wistiaEmbedScript.src = 'https://fast.wistia.com/embed/1n1c7tnsqb.js';
    wistiaEmbedScript.async = true;
    wistiaEmbedScript.type = 'module';
    document.head.appendChild(wistiaEmbedScript);
    const wistiaStyle = document.createElement('style');
    wistiaStyle.textContent = `wistia-player[media-id='1n1c7tnsqb']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1n1c7tnsqb/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
    document.head.appendChild(wistiaStyle);
    // Load GHL form embed script
    const formScript = document.createElement('script');
    formScript.src = 'https://link.msgsndr.com/js/form_embed.js';
    formScript.async = true;
    document.head.appendChild(formScript);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(wistiaEmbedScript);
      document.head.removeChild(wistiaStyle);
      if (document.head.contains(formScript)) document.head.removeChild(formScript);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-459">
      <VslHeader data-id="element-460" />

      {/* Hero Section */}
      <section className="pt-20 md:pt-28 pb-12 md:pb-16 bg-gradient-to-b from-gray-900 to-black" data-id="element-461">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-462">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-6 leading-tight text-center tracking-tight" data-id="element-463">
            Agenda Tu Llamada de Claridad
          </h1>

          <div className="mb-8 rounded-2xl overflow-hidden border-2 border-cyan-500 shadow-2xl" data-id="element-464">
            <wistia-player media-id="1n1c7tnsqb" aspect="1.7777777777777777" data-id="element-465"></wistia-player>
          </div>

          <div className="bg-gradient-to-r from-cyan-900 to-blue-900 rounded-2xl p-6 md:p-8 border-2 border-cyan-500 mb-8 shadow-2xl" data-id="element-466">
            <div className="flex items-start gap-4 mb-4" data-id="element-467">
              <CheckCircle className="w-6 h-6 md:w-7 md:h-7 text-cyan-400 flex-shrink-0 mt-1" data-id="element-468" />
              <div data-id="element-469">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-470">
                  Proceso de Calificación
                </h2>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-471">
                  Para poder hablar con nuestro equipo, primero debemos
                  verificar si eres un buen candidato para esta oportunidad. Por
                  favor, completa el formulario a continuación para agendar tu
                  llamada de claridad.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-800/50 rounded-xl p-6 md:p-8 border border-gray-700 mb-10" data-id="element-472">
            <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-473">
              <Users className="w-6 h-6 text-cyan-400" data-id="element-474" />
              En esta llamada descubrirás:
            </h3>
            <div className="space-y-3" data-id="element-475">
              {['Si 48/hrs AI Cash Machine es adecuado para tu situación actual', 'Cómo implementar el sistema paso a paso en tu negocio', 'Estrategias personalizadas para tu nicho específico', 'Respuestas a todas tus preguntas sobre el programa'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-476">
                  <CheckCircle className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-477" />
                  <span className="text-gray-200 text-sm md:text-base" data-id="element-478">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-16 bg-black" data-id="element-479">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-480">
          <button onClick={() => setShowSurvey(true)} className="group relative w-full max-w-xl mx-auto bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-lg md:text-xl lg:text-2xl uppercase tracking-wide rounded-xl py-5 px-6 shadow-[0_0_30px_rgba(253,185,49,0.3)] transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center gap-3" data-id="element-481">
            APLICAR PARA LA LLAMADA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-482" />
            <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-483">
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-484" />
            </div>
          </button>

          <div className="mt-10 text-center" data-id="element-485">
            <div className="inline-flex items-center gap-2 bg-gray-800/50 border border-gray-700 rounded-full px-6 py-3" data-id="element-486">
              <CheckCircle className="w-5 h-5 text-cyan-400" data-id="element-487" />
              <span className="text-gray-200 text-sm md:text-base" data-id="element-488">
                100% Confidencial • Sin Compromiso • Llamada Gratuita
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="py-12 md:py-16 bg-gradient-to-b from-black to-gray-900" data-id="element-489">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-490">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-6 md:p-8 border border-gray-700" data-id="element-491">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 text-center" data-id="element-492">
              ¿Qué Esperar de la Llamada?
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-493">
              <div className="space-y-3" data-id="element-494">
                <div className="flex items-start gap-3" data-id="element-495">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-496">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-497" />
                  </div>
                  <div data-id="element-498">
                    <p className="font-semibold text-white text-sm" data-id="element-499">
                      Duración: 30-45 minutos
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-500">
                      Tiempo suficiente para conocerte
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-501">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-502">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-503" />
                  </div>
                  <div data-id="element-504">
                    <p className="font-semibold text-white text-sm" data-id="element-505">
                      Formato: Video llamada
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-506">
                      Conexión personal y directa
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-3" data-id="element-507">
                <div className="flex items-start gap-3" data-id="element-508">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-509">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-510" />
                  </div>
                  <div data-id="element-511">
                    <p className="font-semibold text-white text-sm" data-id="element-512">
                      Sin presión de venta
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-513">
                      Solo asesoría honesta
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-514">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-515">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-516" />
                  </div>
                  <div data-id="element-517">
                    <p className="font-semibold text-white text-sm" data-id="element-518">
                      Plan personalizado
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-519">
                      Adaptado a tu situación
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-520" />

      {/* Floating WhatsApp Button */}
      <a href="http://wa.link/holagabriel" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BD5A] w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-all duration-300" aria-label="Chat on WhatsApp" data-id="element-521">
        <svg className="w-8 h-8 md:w-9 md:h-9 text-white" viewBox="0 0 24 24" fill="currentColor" data-id="element-522">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-523" />
        </svg>
      </a>

      {/* Survey Modal */}
      {showSurvey && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setShowSurvey(false)} data-id="element-524">
          <div className="relative w-full max-w-2xl bg-[#111] border border-cyan-500/30 rounded-2xl shadow-[0_0_30px_rgba(0,247,252,0.15)] p-4 md:p-6" onClick={e => e.stopPropagation()} data-id="element-525">
            <button onClick={() => setShowSurvey(false)} className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors" data-id="element-526">
              ✕
            </button>
            <div className="w-full rounded-xl overflow-hidden" style={{
          minHeight: '500px'
        }} data-id="element-527">
              <iframe src="https://api.leadconnectorhq.com/widget/survey/BLdO8dVgeGOcUGykTMOE" style={{
            border: 'none',
            width: '100%',
            height: '600px'
          }} scrolling="no" id="BLdO8dVgeGOcUGykTMOE" title="survey" data-id="element-528" />
            </div>
          </div>
        </div>}
    </div>;
}